import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import antibioticService from '../../services/antibiotic.service';

export const getAntibiotics = createAsyncThunk('antibioticSlice/getAntibiotics', async (thunkAPI) => {
  try {
    const data = await antibioticService.getAntibioticAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  antibioticList: []
};

const antibioticSlice = createSlice({
  name: 'antibioticSlice',
  initialState,
  extraReducers: {
    [getAntibiotics.fulfilled]: (state, action) => {
      state.antibioticList = action.payload.data;
    }
  }
});

const { reducer } = antibioticSlice;
export default reducer;
